import { ErrorMessage, Field, Form, Formik } from 'formik';
import './VisitComponent.scss';
import { Button, Modal } from 'react-bootstrap';
import { IoClose } from 'react-icons/io5';
import FormikFormPhone from '../../../utils/FormikFieldPhoneNumberInput';
import { VisitType } from '../../../constants/enums/VisitType';
import { useState } from 'react';
import { visitValidateSchema } from '../../../utils/yupSchemas/VisitSchema';
import { Link } from 'react-router-dom';
import callBackendAPI from '../../../utils/callBackendAPI';
import { showToastMessage, ToastType } from '../../../utils/ToastOptionCommon';
import Busy from '../../../assets/gif/busy.gif';
import { useSelector } from 'react-redux';
import { loggedInUserState } from '../../../redux/slices/LoginSlice';

interface IProps {
  visitType: VisitType;
  show: boolean;
  propertyId: string;
  initialState: {
    name: string;
    phone: string;
  };
  visitShowHideHandler: () => void;
}

const VisitComponent = (props: IProps) => {
  const { visitType, propertyId } = props;
  const [visit, setVisit] = useState(visitType);
  const [isChecked, setIsChecked] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const userData = useSelector(loggedInUserState);

  const visitSubmitHideHandler = async (values: any) => {
    try {
      setIsLoading(true);
      if (visit === VisitType.Schedule) {
        const response = await callBackendAPI(
          'POST',
          'messaging/createChat',
          null,
          {
            senderId: userData?._id,
            PropertyId: props.propertyId,
            Message: 'Hi, You scheduled a visit for this property.',
          }
        );
        if (response.error) {
          showToastMessage('Error occured!', ToastType.Error);
        } else {
          showToastMessage('Visit scheduled success!', ToastType.Success);
          props.visitShowHideHandler();
        }
      } else if (visit === VisitType.Callback) {
        const response = await callBackendAPI(
          'POST',
          'mail/callbackRequest',
          null,
          { ...values, visit, propertyId }
        );
        if (response.error) {
          showToastMessage('Error occured!', ToastType.Error);
        } else {
          showToastMessage(
            'Callback request send successfully!',
            ToastType.Success
          );
          props.visitShowHideHandler();
        }
      }
    } catch (error) {
      console.error('failed to send request', error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <Modal className='request-modal' show={props.show} centered>
        <Modal.Header className="pt-4">
          <div className="modal-header-content">
          <Modal.Title className="ms-auto">
            {visit === VisitType.Schedule ? (
              <span>Schedule A Visit</span>
            ) : (
              <span>Request A Callback</span>
            )}
          </Modal.Title>
           <p className="modal-subtitle">Enter your details</p>
          </div>
          <div
            onClick={props.visitShowHideHandler}
            className="icons8-close ms-auto"
          >
            <IoClose />
          </div>
        </Modal.Header>

        <Formik
          initialValues={props.initialState}
          enableReinitialize
          validationSchema={visitValidateSchema}
          onSubmit={(values: any) => {
            visitSubmitHideHandler(values);
          }}
        >
          {({ values }) => (
            <Form noValidate>
              <Modal.Body className="">
                <div className="">
                  <div className="">
                    <div className="mb-2">
                      <label htmlFor="name" className="form-label">
                        Enter your name
                      </label>
                      <Field
                        id="name"
                        name="name"
                        type="text"
                        autoComplete="name"
                        required
                        className="form-control"
                        placeholder=""
                      />
                      <ErrorMessage
                        name="name"
                        component="div"
                        className="error"
                      />
                    </div>

                    <div className="mb-2">
                      <label htmlFor="phone" className="form-label">
                        Enter Phone
                      </label>
                      <Field
                        id="phone"
                        name="phone"
                        type="text"
                        autoComplete="phone"
                        required
                        className="form-control"
                        as={FormikFormPhone}
                      />

                      <div className="mb-2 d-flex">
                        <input
                          type="checkbox"
                          className="t-c-check"
                          checked={isChecked}
                          onChange={(e) => setIsChecked(e.target.checked)}
                        />{' '}
                        <div>
                          {visit === VisitType.Schedule && (
                            <>
                              I have read and agreed to the{' '}
                              <Link to="/terms-and-conditions">
                                terms and conditions
                              </Link>{' '}
                              and{' '}
                              <Link to="/privacy-policy">privacy policy</Link>{' '}
                              and hereby confirm to proceed.
                            </>
                          )}
                          {visit === VisitType.Callback && (
                            <>
                              By clicking on submit I agree to
                              <Link to="/terms-and-conditions">
                                {' '}
                                Terms & Conditions.
                              </Link>{' '}
                            </>
                          )}
                        </div>
                      </div>

                      <div className="m-auto my-3">
                        <Button
                          type="submit"
                          className="w-100 py-2 mt-3 mb-2"
                          disabled={!isChecked || isLoading}
                        >
                          {isLoading && (
                            <img
                              src={Busy}
                              alt="loading.."
                              className="me-2 mb-1"
                              style={{ maxWidth: '16px' }}
                            />
                          )}
                          Submit
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>
              </Modal.Body>
            </Form>
          )}
        </Formik>
      </Modal>
    </>
  );
};

export default VisitComponent;
